module.exports = __webpack_public_path__ + "static/media/warning-gray.e619a8eb.svg";